export const parseAlt = (image, pageContext) => {
  if (!image.description) return ''
  for (const loc of image.description.split('\n')) {
    if (loc.substring(0, 5) == `- ${pageContext.lang.toUpperCase()}:`) return loc.substring(6)
  }
  return ''
}

// import { parseAlt } from 'src/helpers'
